import { render, staticRenderFns } from "./user_price.vue?vue&type=template&id=1fd7e97c&scoped=true&"
import script from "./user_price.vue?vue&type=script&lang=js&"
export * from "./user_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd7e97c",
  null
  
)

export default component.exports